import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import MessageConfigurationList from "../screens/masters/messageConfiguration/messageConfigurationList";

const breadCrumbData = [
  { link: "/masters-list", name: "Masters" },
  { link: "/messageConfiguration-list", name: "Message Configuration" }
];

const Home = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <MessageConfigurationList />
    </LayoutContainer>
  </>
);

export default Home;
